// test2672
(2672 && 0);
